export default __webpack_public_path__ + "static/media/cart.806b7bd2.png";